export default {
	section_banner: {
		title: {
			one: 'オンラインで受け付ける &',
		},
		main_title: {
			one: '対面',
		},
		sub_title: {
			one: '支払い',
		},
		paragraph: {
			one: 'JPWorldPay決済は、取引を迅速かつ安全、そして便利に管理する方法を提供します。オンラインでも対面でも、JPWorldPayなら数回タップするだけで支払いを完了できます。',
		},
		cta_buttons: {
			one: 'Contact Now',
			two: 'Download App',
		},
	},

	advantage_sec: {
		label: '入金通知',
		title: {
			one: '競争力を獲得',
			two: 'アドバンテージ',
		},
		paragraph:
			'JPWorldPayは、中小企業がほぼあらゆる場所で決済を受け取れるよう支援します。オンライン、実店舗、外出先など、あらゆる場所で顧客からの支払いをシンプルかつ安全に受け付けます。当社の柔軟で信頼性の高いプラットフォームにより、中小企業は事業展開の場を問わず、より迅速な成長、より多くの顧客へのリーチ、そして容易な取引管理を実現できます。',
	},

	advntage_btm_inn_dwn_1st: {
		label: '支払いオプション',
		title: {
			one: '柔軟性が求められる',
			two: 'お客様',
		},
		paragraph:
			'顧客に後払いを依頼したり、サブスクリプションに登録したり、グローバルまたはローカルの支払いオプションを使用したりすることができます。',
		cta_buttons: '始めましょう',
	},
	advntage_btm_inn_dwn_2nd: {
		label: '受け入れられた支払い',
		title: {
			one: 'グローバルとつながる',
			two: 'バイヤー',
		},
		paragraph:
			'オンラインでも店舗でも、すべての暗号通貨でお支払いいただけます。シームレスなチェックアウトをお楽しみください。',
		cta_buttons: '始めましょう',
	},
	advntage_btm_inn_dwn_3rd: {
		label: 'Make Payments Quickly',
		title: {
			one: '安全なオンラインを受け入れる',
			two: '支払い',
		},
		paragraph:
			'お客様が希望する支払い方法と迅速な決済を実現。JPWorldPayなら、柔軟性とスピードを実現できます。',
		cta_buttons: '始めましょう',
	},

	solution_sec: {
		label: 'オンラインチェックアウト、請求書発行など',
		title: {
			one: '包括的な支払い',
			two: 'ソリューション',
		},
		paragraph:
			'JPWorldPayは、企業がオンライン、実店舗、そしてソーシャルプラットフォーム上で決済を受け付けられる包括的な決済ソリューションを提供しています。オンラインチェックアウト、請求書発行、見積もり、直接支払いなどの機能を備えたJPWorldPayは、企業と顧客双方の取引プロセスを効率化します。また、暗号通貨決済システムとの連携により柔軟性も向上し、安全でシームレスな取引をこれまで以上に容易に実現できます。オンライン販売でも実店舗販売でも、JPWorldPayは決済プロセスを簡素化し、ビジネスのスムーズな成長を支援します。',
	},

	brcv_solution_dsk_1st: {
		label: 'オンラインチェックアウト',
		paragraph:
			'顧客は、サイト、モバイル、アプリでさまざまな支払い方法を単一のソリューションとして使用できます。',
	},
	brcv_solution_dsk_2nd: {
		label: '請求書と見積書',
		paragraph:
			'支払いが簡単な無料のカスタム請求書を送信することで、顧客に支払いを促すことができます。',
	},
	brcv_solution_dsk_3rd: {
		label: 'ソーシャルでのセール',
		paragraph:
			'さまざまなソーシャル メディア プラットフォームで、One Tether 支払いシステムを使用して支払いを受け取ります。',
	},
	brcv_solution_dsk_4th: {
		label: '販売時点管理',
		paragraph:
			'ビジネス用の JPWorldPay 設定を管理し、すべての一般的な取引を受け入れ、売上を追跡します。',
	},
	brcv_solution_dsk_5th: {
		label: '直接支払いを受け入れる',
		paragraph:
			'お客様にショッピング中にお支払いいただきます。その仕組みを学びましょう。シームレスでセルフガイド式の体験です。',
	},
	brcv_solution_dsk_6th: {
		label: 'オンライン決済システム',
		paragraph:
			'当社のクレジットおよび決済サービスを使用して、主要な暗号通貨によるオンラインおよび店頭での支払いを受け入れます。',
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
